export default function HeroSection() {
  return (
    <section id="top" className="relative w-full pt-24 md:pt-28">
      <div className="w-full px-4 md:px-8">
        <div className="relative w-full rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=cinematic%20abstract%20background%20of%20a%20grand%20vintage%20movie%20theater%20with%20warm%20golden%20spotlight%20beams%20cutting%20through%20soft%20haze%2C%20rich%20amber%20and%20deep%20crimson%20tones%2C%20film%20grain%20texture%2C%20dramatic%20moody%20atmosphere%2C%20generous%20dark%20negative%20space&width=1600&height=900&seq=bajie-hero-01&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/70 to-foreground-950/40" />

          <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-8 p-6 sm:p-10 md:p-14">
            <div className="flex flex-col justify-center">
              <span className="inline-flex w-fit items-center gap-2 px-3 py-1 rounded-full bg-primary-500/20 border border-primary-400/40 text-primary-300 text-xs font-medium">
                <i className="ri-fire-line" aria-hidden="true" />
                今日热映 · 全站片单实时更新
              </span>
              <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold leading-tight text-background-50">
                八戒影院
                <span className="block mt-2 text-xl md:text-3xl font-semibold text-primary-300">
                  最新电影 · 电视剧大全 · 好看的片
                </span>
              </h1>
              <p className="mt-5 text-sm md:text-base leading-relaxed text-background-200 max-w-xl">
                这里汇聚院线新片、热播剧集与经典好片，涵盖伦理片、中文字幕与高清资源。
                按片单分类即可快速找到目标内容，无论是追更剧集还是随机选片，都能一处看全。
              </p>
              <div className="mt-7 flex flex-wrap items-center gap-3">
                <a
                  href="#latest"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-foreground-950 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-play-fill text-lg" aria-hidden="true" />
                  浏览最新电影
                </a>
                <a
                  href="#ranking"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50/10 border border-background-200/40 text-background-50 text-sm font-semibold hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-bar-chart-2-line text-lg" aria-hidden="true" />
                  查看热播榜
                </a>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3 md:gap-4">
              <div className="col-span-2 sm:col-span-1 row-span-2 rounded-xl overflow-hidden aspect-[2/3] bg-foreground-900">
                <img
                  src="https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20corridor%20with%20paper%20lanterns%20and%20a%20figure%20in%20hanfu%2C%20warm%20mysterious%20period%20mystery%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p13&orientation=portrait"
                  alt="长安谜案 剧集海报"
                  title="长安谜案 在线观看 - 八戒影院"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="rounded-xl overflow-hidden aspect-[2/3] bg-foreground-900">
                <img
                  src="https://readdy.ai/api/search-image?query=grand%20traditional%20chinese%20courtyard%20mansion%20in%20autumn%20with%20red%20lanterns%2C%20warm%20nostalgic%20period%20drama%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p10&orientation=portrait"
                  alt="家国长卷 剧集海报"
                  title="家国长卷 在线观看 - 八戒影院"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="rounded-xl overflow-hidden aspect-[2/3] bg-foreground-900">
                <img
                  src="https://readdy.ai/api/search-image?query=rain%20soaked%20cobblestone%20alley%20at%20dusk%20with%20a%20solitary%20figure%20in%20a%20long%20coat%2C%20warm%20amber%20streetlight%20glow%2C%20moody%20crime%20noir%20film%20poster%20art%2C%20no%20text&width=400&height=600&seq=bajie-p01&orientation=portrait"
                  alt="雾都迷踪 影片海报"
                  title="雾都迷踪 在线观看 - 八戒影院"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}